import type { AeEvaluatedQuestion, AeEvaluatedSection } from '@/types/assessmentEngine';

/** Walk evaluated section tree; return visible questions in document order. */
export function flattenVisibleQuestions(sections: AeEvaluatedSection[]): AeEvaluatedQuestion[] {
  const out: AeEvaluatedQuestion[] = [];
  const walk = (list: AeEvaluatedSection[]) => {
    for (const sec of list) {
      if (!sec.visible) continue;
      out.push(...sec.questions.filter((q) => q.visible));
      walk(sec.subsections);
    }
  };
  walk(sections);
  // sort_order is scoped per section — do not re-sort globally or preview/take order breaks.
  return out;
}
